"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.advertMapper = void 0;
const dot = require("dot-object");
const advert_map_1 = require("./advert.map");
const flip_1 = require("./flip");
const advertMapper = () => {
    function left2Right(data, target) {
        let FIELDS_MAP;
        if (data._model === "latest") {
            return data;
        }
        else {
            FIELDS_MAP = (typeof data._$document !== "undefined") ? advert_map_1.ADVERT_MAP_V1 : advert_map_1.ADVERT_MAP_V0;
            data._$map = (typeof data._$document !== "undefined") ? "ADVERT_MAP_V1" : "ADVERT_MAP_V0";
        }
        for (const prop in data) {
            if (prop === 'label') {
                continue;
            }
            if (Object.prototype.hasOwnProperty.call(target, prop) && Object.prototype.hasOwnProperty.call(data, prop)) {
                target[prop] = data[prop];
            }
        }
        const inversedMap = (0, flip_1.flip)(FIELDS_MAP);
        for (const leftField in inversedMap) {
            const rightField = inversedMap[leftField];
            if (typeof FIELDS_MAP[rightField] === 'function') {
                let value = FIELDS_MAP[rightField](data);
                dot.override = true;
                dot.str(rightField, value, target);
            }
            else {
                dot.copy(leftField, rightField, data, target);
            }
        }
        return target;
    }
    function rightToLeft(output, original) {
        let FIELDS_MAP = advert_map_1.ADVERT_MAP_V1;
        const inverseGuesser = true;
        for (const leftField in FIELDS_MAP) {
            if (typeof FIELDS_MAP[leftField] === 'function') {
                let value = FIELDS_MAP[leftField](original, inverseGuesser);
                dot.override = true;
                dot.str(leftField, value, output);
            }
            else {
                dot.copy(leftField, FIELDS_MAP[leftField], original, output);
            }
        }
        return output;
    }
    return {
        map(data, direction, target) {
            data.id = `${data.id}`;
            if (direction === '->') {
                return left2Right(data, target);
            }
            else if (direction === '<-') {
                return rightToLeft(data, target);
            }
        },
    };
};
exports.advertMapper = advertMapper;
//# sourceMappingURL=advert.mapper.js.map